export default function reducer(state = [], action) {
    switch (action.type) {
        case 'FIELD_LAYOUT/SET':
            return action.fields;
        case 'FIELD_LAYOUT/CLEAR':
            return null;
        default:
            return state;
    }
}